import { c as _c } from "react/compiler-runtime";
import { styled } from '@precis-digital/kurama/utils';
import Tooltip from '@precis-digital/kurama/Tooltip';
import Typography from '@precis-digital/kurama/Typography';
import { isValidElement, type ComponentProps, type ReactElement } from 'react';
type TypographyTruncatedProps = ComponentProps<typeof Typography>;
const TypographyTruncated = t0 => {
  const $ = _c(20);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      title: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const title = t1 === undefined ? "" : t1;
  if (typeof children === "string") {
    let t2;
    if ($[4] !== children || $[5] !== props) {
      t2 = <StyledTypographyTruncated {...props}>{children}</StyledTypographyTruncated>;
      $[4] = children;
      $[5] = props;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== children || $[8] !== t2) {
      t3 = <Tooltip title={children} kind="singleline">{t2}</Tooltip>;
      $[7] = children;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (isValidElement(children)) {
    const t2 = title ?? "";
    let t3;
    if ($[10] !== children || $[11] !== props) {
      t3 = <StyledTypographyTruncated {...props}>{children}</StyledTypographyTruncated>;
      $[10] = children;
      $[11] = props;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] !== children || $[14] !== t2 || $[15] !== t3) {
      t4 = <Tooltip kind="multiline" title={t2} body={children}>{t3}</Tooltip>;
      $[13] = children;
      $[14] = t2;
      $[15] = t3;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    return t4;
  }
  let t2;
  if ($[17] !== children || $[18] !== props) {
    t2 = <StyledTypographyTruncated {...props}>{children}</StyledTypographyTruncated>;
    $[17] = children;
    $[18] = props;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};
const StyledTypographyTruncated = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  width: 'content-fit'
});
export default TypographyTruncated;